import { BsTools } from "react-icons/bs";
import { IoIosPeople } from "react-icons/io";
import { SiFigshare } from "react-icons/si";
import zainLogo from "../images/zain-logo.png";
import imgClupCard from "../images/img3.jpg";

export const dataCards = [
    {
        icon : <BsTools />,
        title : "اسعار المواد",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
        links : "price-item",
    },
    {
        icon : <SiFigshare />,
        title : "الشركات",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
        links : "companies"
    },
    {
        icon : <IoIosPeople />,
        title : "ملتقى السجانة",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
        links: "sgana-club",
    },
]
;


export const priceItem = [
    {
        category : "مواد البناء والتشييد",
        items : [
            {
                name : "منتج 1",
                price : "0.0"
            },
            {
                name : "منتج 2",
                price : "0.0"
            },
            {
                name : "منتج 3",
                price : "0.0"
            },
        ]
    },
    {
        category : "مواد البناء والتشييد",
        items : [
            {
                name : "منتج 1",
                price : "0.0"
            },
            {
                name : "منتج 2",
                price : "0.0"
            },
            {
                name : "منتج 3",
                price : "0.0"
            },
        ]
    },
    {
        category : "مواد البناء والتشييد",
        items : [
            {
                name : "منتج 1",
                price : "0.0"
            },
            {
                name : "منتج 2",
                price : "0.0"
            },
            {
                name : "منتج 3",
                price : "0.0"
            },
        ]
    },
    {
        category : "مواد البناء والتشييد",
        items : [
            {
                name : "منتج 1",
                price : "0.0"
            },
            {
                name : "منتج 2",
                price : "0.0"
            },
            {
                name : "منتج 3",
                price : "0.0"
            },
        ]
    },
    {
        category : "مواد البناء والتشييد",
        items : [
            {
                name : "منتج 1",
                price : "0.0"
            },
            {
                name : "منتج 2",
                price : "0.0"
            },
            {
                name : "منتج 3",
                price : "0.0"
            },
        ]
    },
];




export const companies = [
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
    {
        logo : zainLogo,
        name : "شركة زين للاتصالات والانترنت"
    },
]


export const dataClubCard = [
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
    {
        img: imgClupCard,
        title : "موضوع الملتقى او عنوان",
        body : 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
    },
]